export default __webpack_public_path__ + "static/media/Notification_Icon.e92b4ae7.svg";